/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Aggregated metrics for a single tool
 */
export type ToolMetric = {
  /**
   * Average latency in milliseconds
   */
  avgLatencyMs: number;
  /**
   * Total number of calls
   */
  callCount: number;
  /**
   * Number of failed calls
   */
  failureCount: number;
  /**
   * Failure rate (0.0 to 1.0)
   */
  failureRate: number;
  /**
   * Tool URN
   */
  gramUrn: string;
  /**
   * Number of successful calls
   */
  successCount: number;
};

/** @internal */
export const ToolMetric$inboundSchema: z.ZodMiniType<ToolMetric, unknown> = z
  .pipe(
    z.object({
      avg_latency_ms: z.number(),
      call_count: z.int(),
      failure_count: z.int(),
      failure_rate: z.number(),
      gram_urn: z.string(),
      success_count: z.int(),
    }),
    z.transform((v) => {
      return remap$(v, {
        "avg_latency_ms": "avgLatencyMs",
        "call_count": "callCount",
        "failure_count": "failureCount",
        "failure_rate": "failureRate",
        "gram_urn": "gramUrn",
        "success_count": "successCount",
      });
    }),
  );

export function toolMetricFromJSON(
  jsonString: string,
): SafeParseResult<ToolMetric, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolMetric$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolMetric' from JSON`,
  );
}
